'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _awaitAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var MAX_MSG_SIZE = 1 << 20; // 1MB

/**
 * Creates an iterable transform that restricts message sizes to
 * the given maximum size.
 * @param {number} [max] The maximum message size. Defaults to 1MB
 * @returns {*} An iterable transform.
 */

module.exports = function (max) {
  max = max || MAX_MSG_SIZE;

  var checkSize = function checkSize(msg) {
    if (msg.data && msg.data.length > max) {
      throw Object.assign(new Error('message size too large!'), {
        code: 'ERR_MSG_TOO_BIG'
      });
    }
  };

  return function (source) {
    return function () {
      var _restrictSize = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, msg;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _context.prev = 2;
                _iterator = _asyncIterator(source);

              case 4:
                _context.next = 6;
                return _awaitAsyncGenerator(_iterator.next());

              case 6:
                _step = _context.sent;
                _iteratorNormalCompletion = _step.done;
                _context.next = 10;
                return _awaitAsyncGenerator(_step.value);

              case 10:
                _value = _context.sent;

                if (_iteratorNormalCompletion) {
                  _context.next = 19;
                  break;
                }

                msg = _value;

                if (Array.isArray(msg)) {
                  msg.forEach(checkSize);
                } else {
                  checkSize(msg);
                }

                _context.next = 16;
                return msg;

              case 16:
                _iteratorNormalCompletion = true;
                _context.next = 4;
                break;

              case 19:
                _context.next = 25;
                break;

              case 21:
                _context.prev = 21;
                _context.t0 = _context["catch"](2);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 25:
                _context.prev = 25;
                _context.prev = 26;

                if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                  _context.next = 30;
                  break;
                }

                _context.next = 30;
                return _awaitAsyncGenerator(_iterator.return());

              case 30:
                _context.prev = 30;

                if (!_didIteratorError) {
                  _context.next = 33;
                  break;
                }

                throw _iteratorError;

              case 33:
                return _context.finish(30);

              case 34:
                return _context.finish(25);

              case 35:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 21, 25, 35], [26,, 30, 34]]);
      }));

      function restrictSize() {
        return _restrictSize.apply(this, arguments);
      }

      return restrictSize;
    }()();
  };
};

module.exports.MAX_MSG_SIZE = MAX_MSG_SIZE;